module.exports = __webpack_public_path__ + "img/9791185072586.6c0cd78c.jpg";